import React, {PureComponent} from 'react';
import {Alert} from "react-bootstrap";

class Informations extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            array: [],
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.selected !== this.props.selected || prevProps.contraintes !== this.props.contraintes) this.updateRender();
    }

    updateRender() {
        let newArray = [...this.state.array];
        let index, text;

        if (this.props.selected !== null && this.props.contraintes !== null) {

            text = `Attention, votre proposition de PAE dépasse 60 crédits.<br/>Soumettre cette proposition entrainera un risque pour votre finançabilité lors de l'année académique suivante.`;
            index = newArray.findIndex(f => f.text === text);

            if (this.props.selected.ECTS > 60) {
                if (index === -1) {
                    newArray.push({text: text, show: true, red: true});
                } else {
                    newArray[index].show = true;
                }
            } else {
                if (index !== -1) {
                    newArray[index].show = false;
                }
            }

            text = `Vous avez composé un PAE inférieur à ${this.props.contraintes.ECTSMin} crédits.`;
            index = newArray.findIndex(f => f.text === text);

            if (this.props.selected.ECTS < this.props.contraintes.ECTSMin) {
                if (index === -1) {
                    newArray.push({text: text, show: true, red: true});
                } else {
                    newArray[index].show = true;
                }
            } else {
                if (index !== -1) {
                    newArray[index].show = false;
                }
            }

            text = `La limite du nombre de crédit envisageable dans votre PAE est de maximum ${this.props.contraintes.ECTSMax} crédits.`;
            index = newArray.findIndex(f => f.text === text);

            if (this.props.selected.ECTS > this.props.contraintes.ECTSMax) {
                if (index === -1) {
                    newArray.push({text: text, show: true, red: true});
                } else {
                    newArray[index].show = true;
                }
            } else {
                if (index !== -1) {
                    newArray[index].show = false;
                }
            }

            newArray.forEach(f => {
                if (f.text.includes("a comme corequis")) {
                    f.show = false;
                }
            });


            this.props.selected.item.forEach(i => {
                i.Corequis.forEach(c => {
                    text = `${i.UniteEnseignementCode} a comme corequis ${c.RequisCode} et ce dernier ne fait visiblement pas encore partie de votre PAE.`;
                    index = newArray.findIndex(f => f.text === text);

                    if (!c.IsValid && !i.IsOption && !this.props.selected.item.map(m => m.UniteEnseignementCode).includes(c.RequisCode)) {
                        if (index === -1) {
                            newArray.push({text: text, show: true});
                        } else {
                            newArray[index].show = true;
                        }
                    }
                })
            })

            this.setState({
                array: newArray,
            })
        }
    }

    render() {
        return (
            <div>
                <Alert className={"mb-5"} variant={"warning"}>
                    <ul className={"animateUL"}>
                        {this.state.array.length > 0 && this.state.array.map((a, key) => <li
                            style={{"--animation-order": key + 1}}
                            className={(a.show ? " " : "hide ") + (a.red ? "text-danger" : "")}
                            key={key}
                            dangerouslySetInnerHTML={{__html: a.text}}/>)}
                    </ul>
                </Alert>
            </div>
        );
    }
}

export default Informations;